

















































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { Message } from "view-design";

@Component({
  components: {},
})
export default class OrderTravelDate extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) orderId: number;
  orderTeeDates: any = [];
  orderTeeDatesCopy: any = [];
  cancel() {
    // (this.$refs.loginForm as any).resetFields();
    this.$emit("input", false);
  }
  save() {
    console.log(this.orderTeeDates, "orderTeeDatesCopy");
    console.log("点击了修改");
    this.$store
      .dispatch("order/UpdateOrderTeeDates", {
        orderTeeDates: this.orderTeeDates,
      })
      .then((res) => {
        this.$Message.success("修改成功");
        this.$emit("input", false);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      if (this.orderId) {
        this.$store
          .dispatch("order/get", {
            id: this.orderId,
          })
          .then((res) => {
            if (res && res.orderTeeDates && res.orderTeeDates.length > 0) {
              this.orderTeeDates = res.orderTeeDates;
              this.orderTeeDatesCopy = res.orderTeeDates;
            }
          });
      }
    }
  }
  changeDate(e, index) {
    this.$set(this.orderTeeDatesCopy, index, {
      teeDate: e,
      id: this.orderTeeDates[index].id,
      teeTime: this.orderTeeDates[index].teeTimeEx,
      teeTimeEx: this.orderTeeDates[index].teeTimeEx,
    });
  }
  changeTime(e, index) {
    this.$set(this.orderTeeDates, index, {
      teeDate: this.orderTeeDatesCopy[index].teeDate,
      id: this.orderTeeDates[index].id,
      teeTimeEx: e,
      teeTime: e,
    });
  }
  rules = {
    // userNameOrEmailAddress: [
    //   {
    //     required: true,
    //     message: this.L("UserNameRequired"),
    //     trigger: "blur",
    //   },
    // ],
    // password: [
    //   {
    //     required: true,
    //     message: this.L("PasswordRequired"),
    //     trigger: "blur",
    //   },
    // ],
  };
}
